export const reportTextMap: Record<ReportType, string> = {
  FALSE_INFORMATION: '허위 사실 유포',
  ABUSE_HATE_SPEECH: '욕설, 혐오, 비방 및 갈등 조장',
  ADVERTISEMENT_SPAM: '광고, 스팸, 도배성 메시지',
  ILLEGAL_FRAUD: '불법, 사기 행위',
  OTHER_REASON: '기타 사유 (최소 10자)',
};

export enum ReportEnum {
  FALSE_INFORMATION = 'FALSE_INFORMATION',
  ABUSE_HATE_SPEECH = 'ABUSE_HATE_SPEECH',
  ADVERTISEMENT_SPAM = 'ADVERTISEMENT_SPAM',
  ILLEGAL_FRAUD = 'ILLEGAL_FRAUD',
  OTHER_REASON = 'OTHER_REASON',
}

export type ReportType = keyof typeof ReportEnum;
